package at.theatervogelweide.admin.web.components

/**
 * Typed BEM class names of the design system: `Bem("admin-card")` is the block, `.element("title")` the
 * `admin-card__title` element, `.modifier("primary")` a variant. State never becomes a modifier; it goes into ARIA
 * attributes, which the styles read.
 */
class Bem(val block: String) {
    init {
        require(block.startsWith("admin-") && NAME.matches(block)) { "Not an admin block name: $block" }
    }

    fun element(name: String) = BemElement(this, name)

    fun modifier(name: String): String = "$block--${checkedName(name)}"

    override fun toString() = block

    override fun equals(other: Any?) = other is Bem && other.block == block

    override fun hashCode() = block.hashCode()
}

/** An element; elements never nest in names (`admin-card__footer-spacer`, not `admin-card__footer__spacer`). */
class BemElement(val block: Bem, name: String) {
    val name = checkedName(name)

    val className: String get() = "${block.block}__$name"

    fun modifier(name: String): String = "${className}--${checkedName(name)}"

    override fun toString() = className

    override fun equals(other: Any?) = other is BemElement && other.className == className

    override fun hashCode() = className.hashCode()
}

private val NAME = Regex("^[a-z0-9]+(-[a-z0-9]+)*$")

private fun checkedName(name: String): String {
    require(NAME.matches(name)) { "Not a BEM name: $name" }
    return name
}
